module.exports = __webpack_public_path__ + "static/media/bw.dc5c813b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bw.svg
// module id = 2055
// module chunks = 0